import Reservations                                               from "../../../domain/reservation/Reservations";
import { ACTION_TYPE, ReservationsAction, SetReservationsAction } from "./ReservationsAction";

const reservationsReducer = (state: Reservations = new Reservations(), action: ReservationsAction): Reservations => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_RESERVATIONS:
      return (action as SetReservationsAction).reservations;
  }
};

export default reservationsReducer;
